<template>
  <BaseInvitation
    question-text="frequently_hints.contract.text"
    question="frequently_hints.contract"

  >
    <div v-if="isFirstLoadPending && isLoading">
      <BaseItemLoader
        :loaderDistribution="['w-9/12', 'w-3/12']"
        v-for="index in 3"
        :key="index"
      />
    </div>
    <div v-else class="cabinet_invitation">
      <ContractInvitation
        @refresh="getContractInvitations"
        v-if="contractInvitation"
        :invitations="contractInvitation"
        @refreshInvitations="getContractInvitations"
        :user-id="user.id"
      >
      </ContractInvitation>
    </div>
  </BaseInvitation>
</template>

<script>
import { mapGetters } from "vuex";
import BaseInvitation from "./components/BaseInvitation.vue";
import entityMixin from "~/mixins/entity";
import { isMobile } from "~/mixins/isMobile";
import baseMixin from "~/mixins/base";
import ContractInvitation from "~/views/Invitation/components/ContractInvitation.vue";

export default {
  name: "InfoProfile",
  components: {
    ContractInvitation,
    BaseInvitation
  },
  mixins: [entityMixin, isMobile, baseMixin],

  data() {
    const isFirstLoadPending = this.$store.state.userInvitationContract.isInitialLoadPending;
    return {
      isFirstLoadPending
    };
  },
  created() {
      this.loadData(() => {
        this.fetchData();
      });
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      contractInvitation: "userInvitationContract/list",
      isInitialLoadPending: "userInvitationCounterparty/isInitialLoadPending",
    })
  },
  methods: {
    fetchData() {
      this.$store.dispatch(
        "userInvitationContract/fetchUserInvitationContracts",
        this.user.id
      );
    },
    getContractInvitations: function() {
      this.loadData(() => {
        this.$store.dispatch(
          "userInvitationContract/fetchUserInvitationContracts",
          this.user.id
        );
      });
    }
  }
};
</script>
